var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17.9204,
    transform: "translate(0 0.977539)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74854 14.8893L4.30003 17.3156C3.94485 17.4994 3.50728 17.3693 3.31147 17.0217V17.0217C3.25482 16.914 3.22426 16.7947 3.22223 16.6731V5.9223C3.22223 3.87191 4.62955 3.05176 6.65472 3.05176H11.4122C13.3755 3.05176 14.8447 3.81723 14.8447 5.7856V16.6731C14.8447 16.8671 14.7673 17.0531 14.6295 17.1903C14.4918 17.3274 14.3049 17.4044 14.1101 17.4044C13.9858 17.4025 13.8637 17.3721 13.7531 17.3156L9.27715 14.8893C9.11221 14.8006 8.91348 14.8006 8.74854 14.8893Z",
    fill: "#ff1200",
    stroke: "#ff1200",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkRed);
export default __webpack_public_path__ + "static/media/BookmarkRed.417bbc9200250e9a5671c5ffb808c337.svg";
export { ForwardRef as ReactComponent };